module.exports = __webpack_public_path__ + "img/ic_twitter.1f8c67d8.png";